// import qs from "qs"
// import Jsona from "jsona"
// import ApiService from "@/store/services/api.service"
import ApiService from "./api.service"

export const PageService = {
  showByTitle(slug) {
    return ApiService.get(`pages/${slug}`)
  },
}
